module.exports = __webpack_public_path__ + "static/media/background.79273982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/silicon-valley/background.jpg
// module id = 959
// module chunks = 27